"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseField = exports.parseCurrency = exports.formatField = exports.formatCurrency = void 0;

var _textfieldConfig = require("../fields/Textfield/textfieldConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var TextfieldType = _flowRuntime["default"].tdz(function () {
  return _textfieldConfig.TextfieldType;
});

// Polyfill Number.isNaN for IE
// $FlowExpectedError
Number.isNaN = Number.isNaN || // eslint-disable-next-line func-names
function (value) {
  // eslint-disable-next-line no-self-compare
  return value !== value;
};

var formatCurrency = function formatCurrency(value) {
  if (value) {
    // $FlowExpectedError
    return value / 100;
  }

  return '';
};

exports.formatCurrency = formatCurrency;

var formatField = function formatField(type) {
  if (type === 'currency') {
    return formatCurrency;
  }

  return undefined;
};

exports.formatField = formatField;

var parseCurrency = function parseCurrency(value) {
  if (value) {
    var value2dp = value.match(/^\d+(?:\.\d{0,2})?/);

    if (value2dp) {
      return (Number(value2dp[0]) * 100).toFixed(0);
    }

    return '';
  }

  return '';
};

exports.parseCurrency = parseCurrency;

var parseField = function parseField(type) {
  if (type === 'currency') {
    return parseCurrency;
  }

  return undefined;
};

exports.parseField = parseField;